module.exports = __webpack_public_path__ + "img/checkbox-unchecked.2efcad9.png";